import type { PayloadError } from 'relay-runtime';
import { stopCaptureGraphQlErrors } from '@atlassian/jira-relay-errors';

type PayloadErrorWithExtensions = PayloadError & { extensions?: { statusCode?: number } };

const getGraphQLErrorsForOperation = (
	errorCollector: string,
	operationName: string,
): PayloadErrorWithExtensions[] => {
	const errorsWithMeta = stopCaptureGraphQlErrors(errorCollector);
	if (Array.isArray(errorsWithMeta)) {
		return errorsWithMeta
			.filter((errorWithMeta) => errorWithMeta.meta.operationName === operationName)
			.flatMap((errorWithMeta) => errorWithMeta.errors);
	}
	return [];
};

export const getErrorsAndStopCapture = (
	errorCollector: string,
	graphQLOperationName: string,
): {
	isError: boolean;
	isPermissionError: boolean;
	cause: string;
	statusCode: number | undefined;
} => {
	const relevantErrors = getGraphQLErrorsForOperation(errorCollector, graphQLOperationName);
	const isError = relevantErrors.length > 0;
	const isPermissionError =
		isError &&
		relevantErrors.some((relevantError) => relevantError?.extensions?.statusCode === 403);

	return {
		isError,
		isPermissionError,
		cause: relevantErrors[0]?.message ?? '',
		statusCode: relevantErrors[0]?.extensions?.statusCode,
	};
};
